const uxErActivate = (root, idx) => {
  root.querySelectorAll('[data-er-idx]').forEach((el) => {
    el.classList.toggle('is-active', el.getAttribute('data-er-idx') === idx);
  });
};

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-er-go]');
  if (!trigger) return;

  const root = trigger.closest('[data-ux-er]');
  if (!root) return;

  uxErActivate(root, trigger.getAttribute('data-er-go'));
});

let uxErSwipeMedia = null;
let uxErSwipeX = 0;
let uxErSwipeY = 0;

document.addEventListener('touchstart', (event) => {
  const media = event.target.closest('.ux-er__media');
  if (!media) return;
  uxErSwipeMedia = media;
  uxErSwipeX = event.touches[0].clientX;
  uxErSwipeY = event.touches[0].clientY;
}, { passive: true });

document.addEventListener('touchend', (event) => {
  const media = uxErSwipeMedia;
  uxErSwipeMedia = null;
  if (!media) return;

  const dx = event.changedTouches[0].clientX - uxErSwipeX;
  const dy = event.changedTouches[0].clientY - uxErSwipeY;
  if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

  const root = media.closest('[data-ux-er]');
  if (!root) return;

  const steps = Array.from(root.querySelectorAll('.ux-er__step'));
  if (steps.length < 2) return;

  const indices = steps.map((el) => el.getAttribute('data-er-idx'));
  const activeStep = root.querySelector('.ux-er__step.is-active');
  const current = activeStep ? indices.indexOf(activeStep.getAttribute('data-er-idx')) : 0;

  let next = dx < 0 ? current + 1 : current - 1;
  if (next < 0) next = 0;
  if (next > indices.length - 1) next = indices.length - 1;
  if (next === current) return;

  uxErActivate(root, indices[next]);
}, { passive: true });